import Dropdown from 'components/base/Dropdown';
import React from 'react';
import {
  StyledDescription,
  StyledInputWrapper,
  StyledSelectorTitle
} from './ReportedMetricsModal.style';

export const AGGREGATION_OPTIONS = {
  AVERAGE: {
    value: 'avg',
    displayValue: 'Average',
    searchableValue: 'Average'
  },
  SUM: { value: 'sum', displayValue: 'Sum', searchableValue: 'Sum' },
  COUNT: { value: 'count', displayValue: 'Count', searchableValue: 'Count' },
  DISTINCT_COUNT: {
    value: 'count_distinct',
    displayValue: 'Distinct Count',
    searchableValue: 'Distinct Count'
  },
  P_50: { value: 'p50', displayValue: 'p50', searchableValue: 'p50' },
  P_75: { value: 'p75', displayValue: 'p75', searchableValue: 'p75' }
};

export const AggregationSelector = ({ modalState, setModalState }) => (
  <StyledInputWrapper>
    <StyledSelectorTitle>AGGREGATION</StyledSelectorTitle>
    <StyledDescription>
      Set aggregation to determine how individual data points are combined or
      summarized within the chart
    </StyledDescription>
    <Dropdown
      selectedValue={modalState.aggregation}
      onChange={aggregation => {
        setModalState({
          ...modalState,
          aggregation,
          ...(aggregation !== AGGREGATION_OPTIONS.DISTINCT_COUNT.value && {
            distinctCount: null
          })
        });
      }}
      options={Object.values(AGGREGATION_OPTIONS)}
      placeholder='Select Option'
    />
  </StyledInputWrapper>
);
